import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Sidebar.css';

export default function Sidebar() {
  const { account, isSuperAdmin, isSwitchedFromSuperAdmin, logout, backToSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleBackToSuperAdmin = () => {
    backToSuperAdmin();
    navigate('/superadmin');
  };

  const closeMenu = () => setIsOpen(false);

  const handleNavClick = () => {
    if (window.innerWidth <= 768) {
      closeMenu();
    }
  };

  return (
    <>
      <button
        type="button"
        className="sidebar-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={isOpen ? 'إغلاق القائمة' : 'فتح القائمة'}
        aria-expanded={isOpen}
      >
        <span className={`hamburger-icon ${isOpen ? 'open' : ''}`}>
          <span />
          <span />
          <span />
        </span>
      </button>

      {isOpen && (
        <div className="sidebar-overlay" onClick={closeMenu} aria-hidden="true" />
      )}

      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-brand">
        <span className="brand-icon">&#9881;</span>
        <h2>لوحة التحكم</h2>
      </div>

      {account && (
        <div className="sidebar-account">
          <span className="account-name">{isSuperAdmin ? 'المدير العام' : account.title}</span>
        </div>
      )}

      {isSwitchedFromSuperAdmin && !isSuperAdmin && (
        <button className="back-to-sa-btn" onClick={() => { handleBackToSuperAdmin(); handleNavClick(); }}>
          <span className="nav-icon">&#128081;</span>
          العودة للمدير العام
        </button>
      )}

      <nav className="sidebar-nav">
        {isSuperAdmin && (
          <>
            <NavLink to="/superadmin" end onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active nav-superadmin' : 'nav-item nav-superadmin'}>
              <span className="nav-icon">&#128081;</span>
              <span className="nav-item-text">
                إدارة الحسابات
                <span className="nav-item-hint">المدير العام · SMS ترحيب</span>
              </span>
            </NavLink>
            <NavLink to="/superadmin/inbox" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128236;</span>
              صندوق SMS
            </NavLink>
            <NavLink to="/superadmin/join-requests" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128233;</span>
              طلبات الانضمام
            </NavLink>
            <NavLink to="/superadmin/categories" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128449;</span>
              إدارة الفئات
            </NavLink>
            <NavLink to="/superadmin/users" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128101;</span>
              المستخدمون
            </NavLink>
            <NavLink to="/superadmin/blacklist" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128683;</span>
              حظر الحجوزات
            </NavLink>
            <NavLink to="/superadmin/send-sms" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128172;</span>
              إرسال SMS
            </NavLink>
            <NavLink to="/superadmin/sms" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#9993;</span>
              رسائل SMS
            </NavLink>
          </>
        )}
        {!isSuperAdmin && (
          <>
            <NavLink to="/" end onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#127968;</span>
              الرئيسية
            </NavLink>
            <NavLink to="/account" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128100;</span>
              <span className="nav-item-text">
                بيانات الحساب
                <span className="nav-item-hint">الاسم · الوصف · التواصل</span>
              </span>
            </NavLink>
            <NavLink to="/branding" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128247;</span>
              <span className="nav-item-text">
                الشعار والمعرض
                <span className="nav-item-hint">شعار · ألبوم الصور</span>
              </span>
            </NavLink>
            <NavLink to="/reservation-types" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128203;</span>
              أنواع الحجز
            </NavLink>
            <NavLink to="/settings" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#9202;</span>
              إعدادات العمل
            </NavLink>
            <NavLink to="/customers" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#11088;</span>
              العملاء
            </NavLink>
            <NavLink to="/client-access" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128274;</span>
              إدارة الوصول
            </NavLink>
            <NavLink to="/search" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#128269;</span>
              بحث بالهاتف
            </NavLink>
            <NavLink to="/contact" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <span className="nav-icon">&#9993;</span>
              تواصل معنا
            </NavLink>
          </>
        )}
        {isSuperAdmin && (
          <NavLink to="/contact" onClick={handleNavClick} className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            <span className="nav-icon">&#9993;</span>
            تواصل معنا
          </NavLink>
        )}
      </nav>

      <button className="logout-btn" onClick={handleLogout}>
        <span className="nav-icon">&#128682;</span>
        تسجيل الخروج
      </button>
    </aside>
    </>
  );
}
